export const validateEmail = (email) => RegExp('^\\S+@\\S+\\.\\S+$').test(email);
